module.exports = __webpack_public_path__ + "img/left-field-deck.2d96a105.svg";